import { render, staticRenderFns } from "./dangerAreaGoodsCirculation.vue?vue&type=template&id=1ba6ff88&scoped=true"
import script from "./dangerAreaGoodsCirculation.vue?vue&type=script&lang=js"
export * from "./dangerAreaGoodsCirculation.vue?vue&type=script&lang=js"
import style0 from "./dangerAreaGoodsCirculation.vue?vue&type=style&index=0&id=1ba6ff88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba6ff88",
  null
  
)

export default component.exports